module.exports = __webpack_public_path__ + "static/media/Boreal-Besties.6153d8df.jpg";